/** Client build-time configuration. Only `VITE_*` variables are exposed to the browser. */
export const clientConfig = {
  serverUrl: import.meta.env.VITE_SERVER_URL ?? 'http://localhost:2567',
} as const;
